<template>
	<div class="modal" id="popup-success">
		<div class="modal-form">
			<div class="modal-form__title">{{ popupData.title }}</div>
			<div class="form-confirm">
				<p v-html="popupData.message"></p>
				<button class="btn color shadow" data-fancybox-close>Закрыть</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "PopupSuccess",
	computed: {
		...mapGetters({
			popupData: 'getPopupSuccessData'
		})
	},
	methods: {}
}
</script>

<style scoped></style>